import React, { Suspense } from "react";
import { lazyWithRetry } from "../utils/lazyWithRetry";

const ClipperCompareRoute = lazyWithRetry(() =>
  import("./ClipperCompareRoute").then((m) => ({
    default: m.ClipperCompareRoute,
  })),
);

const LoadingFallback = () => <div style={{ width: "100%", height: "100%" }} />;

export const ClipperCompareRouteLazy = (props: any) => (
  <Suspense fallback={<LoadingFallback />}>
    <ClipperCompareRoute {...props} />
  </Suspense>
);
